import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import axios from "axios";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function LoadingError({ error }: { error?: Error }) {
  const { t } = useTranslation();
  const errorString = useMemo(() => {
    if (axios.isAxiosError(error)) {
      if (typeof error.response?.data === "string") {
        return error.response.data;
      } else {
        return error.message;
      }
    }

    return error?.message;
  }, [error]);

  return (
    <Box py={1} px={3} textAlign="center">
      <Typography variant="h6" color="text">
        {t("loading.errore")}
      </Typography>
      <pre>{errorString}</pre>
    </Box>
  );
}
